/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
    {
        url: '/users',
        i18n: 'Users',
        slug: 'users',
        icon: 'UserIcon'
    },
    {
        url: '/access_groups',
        i18n: 'AccessGroups',
        slug: 'access_groups',
        icon: 'UsersIcon'
    },
    {
        url: '/terminals',
        i18n: 'AccessTerminals',
        slug: 'terminals',
        icon: 'CpuIcon'
    },
    {
        url: '/accesses',
        i18n: 'Accesses',
        slug: 'accesses',
        icon: 'EyeIcon'
    }
]
